import React from 'react';
import {Avatar, Box, Divider, Sheet, Stack} from '@mui/joy';
import Experience from "./Experience";
import {Circle} from "@mui/icons-material";
import {SkillModel} from "../model/skill";
import {ExperienceModel} from "../model/experience";
import Education from "./Education";

function Experiences({experiences} :{experiences: Array<ExperienceModel>}) {
    return (
        <Stack direction='row' sx={{justifyContent: 'space-around', alignItems: 'flex-start', borderRadius: 8,}}>
            <Box display={{xs: 'none', lg: 'block'}}>
                <Avatar  sx={{width:128, height:128}} size='sm' variant='soft' color='primary'>
                    <Circle sx={{fontSize:128}}/>
                </Avatar>
            </Box>

            <Sheet
                variant='soft'
                sx={{
                    paddingY: 2,
                    paddingX:2,
                    width: '100%',
                    maxWidth: 800,
                    borderRadius: 16,
                }}>
                <Stack width='100%' sx={{padding: 0}} justifyContent={{xs: 'start', md: 'space-between'}}
                       direction={{xs: 'column', md: 'row'}}>
                    <Stack minWidth='xs' direction='column' spacing={2}>
                        {
                            experiences.slice(0, Math.round(experiences.length / 2)).map((value, index) => (
                                <Experience experience = {value} number = {index}/>
                            ))
                        }
                    </Stack>
                    <Stack minWidth='xs' paddingTop={{xs: 2, md: 0}} direction='column' spacing={2}>
                        {
                            experiences.slice(Math.round(experiences.length / 2) , experiences.length).map((value, index) => (
                                <Experience experience = {value} number = {index}/>
                            ))
                        }
                    </Stack>
                </Stack>
            </Sheet>
        </Stack>
    );
}

export default Experiences;